module.exports = __webpack_public_path__ + "static/28-7a3d7d1dc6b8446bcbf9af7481e38da1.jpg";